// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import words from 'lodash/words'
import difference from 'lodash/difference'
import uniq from 'lodash/uniq'
import join from 'lodash/join'

const defaultStopwords = [
  "a's",
  'accordingly',
  'again',
  'allows',
  'also',
  'amongst',
  'anybody',
  'anyways',
  'appropriate',
  'aside',
  'available',
  'because',
  'before',
  'below',
  'between',
  'by',
  "can't",
  'certain',
  'com',
  'consider',
  'corresponding',
  'definitely',
  'different',
  "don't",
  'each',
  'else',
  'et',
  'everybody',
  'exactly',
  'fifth',
  'follows',
  'four',
  'gets',
  'goes',
  'greetings',
  'has',
  'he',
  'her',
  'herein',
  'him',
  'how',
  "i'm",
  'immediate',
  'indicate',
  'instead',
  'it',
  'itself',
  'know',
  'later',
  'lest',
  'likely',
  'ltd',
  'me',
  'more',
  'must',
  'nd',
  'needs',
  'next',
  'none',
  'nothing',
  'of',
  'okay',
  'ones',
  'others',
  'ourselves',
  'own',
  'placed',
  'probably',
  'rather',
  'regarding',
  'right',
  'saying',
  'seeing',
  'seen',
  'serious',
  'she',
  'so',
  'something',
  'soon',
  'still',
  "t's",
  'th',
  'that',
  'theirs',
  'there',
  'therein',
  "they'd",
  'third',
  'though',
  'thus',
  'toward',
  'try',
  'under',
  'unto',
  'used',
  'value',
  'vs',
  'way',
  "we've",
  "weren't",
  'whence',
  'whereas',
  'whether',
  "who's",
  'why',
  'within',
  "wouldn't",
  "you'll",
  'yourself',
  'able',
  'across',
  'against',
  'almost',
  'although',
  'an',
  'anyhow',
  'anywhere',
  'are',
  'ask',
  'away',
  'become',
  'beforehand',
  'beside',
  'beyond',
  "c'mon",
  'cannot',
  'certainly',
  'come',
  'considering',
  'could',
  'described',
  'do',
  'done',
  'edu',
  'elsewhere',
  'etc',
  'everyone',
  'example',
  'first',
  'for',
  'from',
  'getting',
  'going',
  'had',
  "hasn't",
  "he's",
  'here',
  'hereupon',
  'himself',
  'howbeit',
  "i've",
  'in',
  'indicated',
  'into',
  "it'd",
  'just',
  'known',
  'latter',
  'let',
  'little',
  'mainly',
  'mean',
  'moreover',
  'my',
  'near',
  'neither',
  'nine',
  'noone',
  'novel',
  'off',
  'old',
  'only',
  'otherwise',
  'out',
  'particular',
  'please',
  'provides',
  'rd',
  'regardless',
  'said',
  'says',
  'seem',
  'self',
  'seriously',
  'should',
  'some',
  'sometime',
  'sorry',
  'sub',
  'take',
  'than',
  "that's",
  'them',
  "there's",
  'theres',
  "they'll",
  'this',
  'three',
  'to',
  'towards',
  'trying',
  'unfortunately',
  'up',
  'useful',
  'various',
  'want',
  'we',
  'welcome',
  'what',
  'whenever',
  'whereby',
  'which',
  'whoever',
  'will',
  'without',
  'yes',
  "you're",
  'yourselves',
  'about',
  'actually',
  "ain't",
  'alone',
  'always',
  'and',
  'anyone',
  'apart',
  "aren't",
  'asking',
  'awfully',
  'becomes',
  'behind',
  'besides',
  'both',
  "c's",
  'cant',
  'changes',
  'comes',
  'contain',
  "couldn't",
  'despite',
  'does',
  'down',
  'eg',
  'enough',
  'even',
  'everything',
  'except',
  'five',
  'former',
  'further',
  'given',
  'gone',
  "hadn't",
  'have',
  'hello',
  "here's",
  'hers',
  'his',
  'however',
  'ie',
  'inasmuch',
  'indicates',
  'inward',
  "it'll",
  'keep',
  'knows',
  'latterly',
  "let's",
  'look',
  'many',
  'meanwhile',
  'most',
  'myself',
  'nearly',
  'never',
  'no',
  'nor',
  'now',
  'often',
  'on',
  'onto',
  'ought',
  'outside',
  'particularly',
  'plus',
  'que',
  're',
  'regards',
  'same',
  'second',
  'seemed',
  'selves',
  'seven',
  "shouldn't",
  'somebody',
  'sometimes',
  'specified',
  'such',
  'taken',
  'thank',
  'thats',
  'themselves',
  'thereafter',
  'thereupon',
  "they're",
  'thorough',
  'through',
  'together',
  'tried',
  'twice',
  'unless',
  'upon',
  'uses',
  'very',
  'wants',
  "we'd",
  'well',
  "what's",
  'where',
  'wherein',
  'while',
  'whole',
  'willing',
  "won't",
  'yet',
  "you've",
  'zero',
  'above',
  'after',
  'all',
  'along',
  'am',
  'another',
  'anything',
  'appear',
  'around',
  'associated',
  'be',
  'becoming',
  'being',
  'best',
  'brief',
  'came',
  'cause',
  'clearly',
  'concerning',
  'containing',
  'course',
  'did',
  "doesn't",
  'downwards',
  'eight',
  'entirely',
  'ever',
  'everywhere',
  'far',
  'followed',
  'formerly',
  'furthermore',
  'gives',
  'got',
  'happens',
  "haven't",
  'help',
  'hereafter',
  'herself',
  'hither',
  "i'd",
  'if',
  'inc',
  'inner',
  'is',
  "it's",
  'keeps',
  'last',
  'least',
  'like',
  'looking',
  'may',
  'merely',
  'mostly',
  'name',
  'necessary',
  'nevertheless',
  'nobody',
  'normally',
  'nowhere',
  'oh',
  'once',
  'or',
  'our',
  'over',
  'per',
  'possible',
  'quite',
  'really',
  'relatively',
  'saw',
  'secondly',
  'seeming',
  'sensible',
  'several',
  'since',
  'somehow',
  'somewhat',
  'specify',
  'sup',
  'tell',
  'thanks',
  'the',
  'then',
  'thereby',
  'these',
  "they've",
  'thoroughly',
  'throughout',
  'too',
  'tries',
  'two',
  'unlikely',
  'us',
  'using',
  'via',
  'was',
  "we'll",
  'went',
  'whatever',
  "where's",
  'whereupon',
  'whither',
  'whom',
  'wish',
  'wonder',
  'you',
  'your',
  'according',
  'afterwards',
  'allow',
  'already',
  'among',
  'any',
  'anyway',
  'appreciate',
  'as',
  'at',
  'became',
  'been',
  'believe',
  'better',
  'but',
  'can',
  'causes',
  'co',
  'consequently',
  'contains',
  'currently',
  "didn't",
  'doing',
  'during',
  'either',
  'especially',
  'every',
  'ex',
  'few',
  'following',
  'forth',
  'get',
  'go',
  'gotten',
  'hardly',
  'having',
  'hence',
  'hereby',
  'hi',
  'hopefully',
  "i'll",
  'ignored',
  'indeed',
  'insofar',
  "isn't",
  'its',
  'kept',
  'lately',
  'less',
  'liked',
  'looks',
  'maybe',
  'might',
  'much',
  'namely',
  'need',
  'new',
  'non',
  'not',
  'obviously',
  'ok',
  'one',
  'other',
  'ours',
  'overall',
  'perhaps',
  'presumably',
  'qv',
  'reasonably',
  'respectively',
  'say',
  'see',
  'seems',
  'sent',
  'shall',
  'six',
  'someone',
  'somewhere',
  'specifying',
  'sure',
  'tends',
  'thanx',
  'their',
  'thence',
  'therefore',
  'they',
  'think',
  'those',
  'thru',
  'took',
  'truly',
  'un',
  'until',
  'use',
  'usually',
  'viz',
  "wasn't",
  "we're",
  'were',
  'when',
  'whereafter',
  'wherever',
  'who',
  'whose',
  'with',
  'would',
  "you'd",
  'yours',
  "he'd",
  "he'll",
  "how's",
  'i',
  "mustn't",
  "shan't",
  "she'd",
  "she'll",
  "she's",
  "when's",
  "why's",
  'make',
  'a',
  'I',
  'www',
  'abst',
  'accordance',
  'act',
  'added',
  'adj',
  'affected',
  'affecting',
  'affects',
  'ah',
  'announce',
  'anymore',
  'apparently',
  'approximately',
  'aren',
  'arent',
  'arise',
  'auth',
  'b',
  'back',
  'begin',
  'beginning',
  'beginnings',
  'begins',
  'biol',
  'briefly',
  'c',
  'ca',
  'couldnt',
  'd',
  'date',
  'due',
  'e',
  'ed',
  'effect',
  'eighty',
  'end',
  'ending',
  'et-al',
  'f',
  'ff',
  'fix',
  'found',
  'g',
  'gave',
  'give',
  'giving',
  'h',
  'hed',
  'heres',
  'hes',
  'hid',
  'home',
  'hundred',
  'id',
  'im',
  'immediately',
  'importance',
  'important',
  'index',
  'information',
  'invention',
  'itd',
  'j',
  'k',
  'kg',
  'km',
  'l',
  'largely',
  'lets',
  'line',
  'll',
  'm',
  'made',
  'makes',
  'means',
  'meantime',
  'mg',
  'million',
  'miss',
  'ml',
  'mr',
  'mrs',
  'mug',
  'n',
  'na',
  'nay',
  'necessarily',
  'ninety',
  'nonetheless',
  'nos',
  'noted',
  'o',
  'obtain',
  'obtained',
  'omitted',
  'ord',
  'owing',
  'p',
  'page',
  'pages',
  'part',
  'past',
  'poorly',
  'possibly',
  'potentially',
  'pp',
  'predominantly',
  'present',
  'previously',
  'primarily',
  'promptly',
  'proud',
  'put',
  'q',
  'quickly',
  'r',
  'ran',
  'readily',
  'recent',
  'recently',
  'ref',
  'refs',
  'related',
  'research',
  'resulted',
  'resulting',
  'results',
  'run',
  's',
  'sec',
  'section',
  'shed',
  'shes',
  'show',
  'showed',
  'shown',
  'showns',
  'shows',
  'significant',
  'significantly',
  'similar',
  'similarly',
  'slightly',
  'somethan',
  'specifically',
  'stop',
  'strongly',
  'substantially',
  'successfully',
  'sufficiently',
  'suggest',
  't',
  'taking',
  "that'll",
  "that've",
  'thered',
  "there'll",
  'thereof',
  'therere',
  'thereto',
  "there've",
  'theyd',
  'theyre',
  'thou',
  'thoughh',
  'thousand',
  'throug',
  'til',
  'tip',
  'ts',
  'u',
  'unlike',
  'ups',
  'usefully',
  'usefulness',
  'v',
  've',
  'vol',
  'vols',
  'w',
  'wasnt',
  'wed',
  'werent',
  "what'll",
  'whats',
  'wheres',
  'whim',
  'whod',
  "who'll",
  'whomever',
  'whos',
  'widely',
  'wont',
  'words',
  'world',
  'wouldnt',
  'x',
  'y',
  'youd',
  'youre',
  'z',
]

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------- Function
// ----------------------------------------------------------------------------
/** removeStopwords */
const removeStopwords = (string, stopwords = defaultStopwords) => {
  const stringAsArray = words(string)
  const withoutStopwords = uniq(difference(stringAsArray, stopwords))
  const returnString = join(withoutStopwords, ', ')
  return returnString
}

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default removeStopwords
